import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { Box, Typography } from "@mui/material";

const DEFAULT_ADMINS = ["simonzilker@yahoo.de"];

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(null); // null = loading

  useEffect(() => {
    if (!user) {
      setAllowed(false);
      return;
    }

    const checkAccess = async () => {
      const userEmail = (user.email || "").toLowerCase();

      // Default-Admins immer erlauben
      if (DEFAULT_ADMINS.includes(userEmail)) {
        setAllowed(true);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "app_config", "access"));
        if (snap.exists()) {
          const users = snap.data().users || [];
          const entry = users.find((u) => (u.email || "").toLowerCase() === userEmail);
          setAllowed(!!entry);
        } else {
          // Kein Access-Doc vorhanden = nur Default-Admins
          setAllowed(false);
        }
      } catch (error) {
        console.error("Fehler beim Pruefen der Zugriffsrechte:", error);
        setAllowed(DEFAULT_ADMINS.includes(userEmail));
      }
    };

    checkAccess();
  }, [user]);

  if (!user) return <Navigate to="/login" />;

  if (allowed === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <Typography>Lade...</Typography>
      </Box>
    );
  }

  if (!allowed) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", flexDirection: "column", gap: 2 }}>
        <Typography variant="h5">Kein Zugriff</Typography>
        <Typography variant="body2" color="text.secondary">
          Dein Account ({user.email}) ist nicht freigeschaltet. Bitte kontaktiere den Administrator.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
